module.exports = __webpack_public_path__ + "static/media/photo-3.9ddc7751.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/alabama-rural-studio/photo-3.jpg
// module id = 151
// module chunks = 0